import { render } from "./IconoPuestaSol.vue?vue&type=template&id=27b01eb8"
import script from "./IconoPuestaSol.vue?vue&type=script&lang=js"
export * from "./IconoPuestaSol.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__